import type { NuxtError } from '#app'
import { createError } from '#imports'
import type { Ref } from 'vue'

export function useHandleError(error: Ref<NuxtError | undefined>) {
  if (!error.value) {
    return
  }

  throw createError({
    status: error.value.status,
    statusText: error.value.message,
    fatal: true,
  })
}
